import { Box, Stack } from '@n26/nxd'
import { useEffect } from 'react'
import { CategorySection } from './CategorySection'
import { PopularSection, type PopularSectionProps } from './PopularSection'
import { LatestSection, type LatestSectionProps } from './LatestSection'
import { SectionWrapper } from './SectionWrapper'
import type { BlogHomeLoaderData } from '@app/routes/$locale.blog'
import { useLocaliseString } from '@hooks/useLocaliseString'
import { OptionSelector } from '@components/OptionSelector'
import { usePageVariations } from '@hooks/usePageVariations'
import type { UrlsPerCountry } from '@constants/countryDetails'

type BlogHomeProps = {
  loaderData: BlogHomeLoaderData
}

export function BlogHome({ loaderData }: BlogHomeProps) {
  const { blogHomePageData } = loaderData || {}
  const {
    contentCollection,
    popularArticlesCollection,
    popularSectionPosition,
    allCategories,
    latestArticles,
    pageVariations,
  } = blogHomePageData || {}
  const { setLocalizedUrls } = usePageVariations()
  useEffect(() => {
    setLocalizedUrls(pageVariations as UrlsPerCountry)
  }, [pageVariations, setLocalizedUrls])
  const localiseString = useLocaliseString()

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      gap='16'
      className='py-[50px]'
    >
      <SectionWrapper asSection={false}>
        <Stack space='16'>
          <h1 className='text-[31px] font-extended'>
            {localiseString('blogHomePageTitle')}
          </h1>
          {allCategories && <OptionSelector options={allCategories} />}
        </Stack>
      </SectionWrapper>
      {latestArticles && (
        <LatestSection
          articles={latestArticles as LatestSectionProps['articles']}
        />
      )}
      {contentCollection.map((section: any, index: number) => {
        if (index + 1 === popularSectionPosition) {
          return (
            <Box key={index} className='w-full'>
              <PopularSection
                articles={
                  popularArticlesCollection as PopularSectionProps['articles']
                }
              />
              <Box className='flex justify-center pt-16'>
                <CategorySection key={index} {...section} />
              </Box>
            </Box>
          )
        }

        return <CategorySection key={index} {...section} />
      })}
    </Box>
  )
}
